<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import SearchList from './SearchList.svelte'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    let searchActive = false

    serviceProvider.searchService.activeSubs.subscribe((status) => (searchActive = status))
</script>

{#if searchActive}
    <SearchList {dataProvider} {serviceProvider}/>
{/if}
